// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2gP4q","tab":"Tabs_tab__gyFxZ","tabActive":"Tabs_tabActive__1oC8s"};